<template>
  <section class="home-hero" id="home-hero">
    <TvaBackgroundVideo
      class="home-hero__video"
      :pathToVideo="`home_${i18n.locale.value}-0`"
      autoPlay
    />
    <HomeHeroContent
      class="home-hero__content"
      :title="title"
      :subtitle="subtitle"
      :languages="languages"
      :smallscreen="smallscreen"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";
import useTvaMq from "@/plugins/tvaMq.js";
import { useI18n } from "vue-i18n";

import HomeHeroContent from "../general/HomeHeroContent.vue";
import TvaBackgroundVideo from "../general/TvaBackgroundVideo.vue";

defineProps({
  title: String,
  subtitle: String,
  languages: {
    type: Array,
    default: () => [],
  },
});

const { $tvaMq } = useTvaMq();
const i18n = useI18n();
const smallscreen = computed(() => ["tablet", "mobile"].includes($tvaMq.value));
</script>

<style lang="scss" scoped>
.home-hero {
  width: 100%;
  height: calc(var(--vh) * 100);

  &__video {
    .desktop &,
    .large & {
      height: calc(var(--vh) * 100);
    }
  }

  .mobile &,
  .tablet & {
    @include home-side-stripes;
    &::before,
    &::after {
      height: 45%;
    }

    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    &__video {
      top: 0;
      height: 45%;
    }
    &__content {
      height: 55%;
    }
  }
}
</style>
